<template>
  <div class="flex flex-row border-b-4 border-red">
    <app-year-selector color="red">
      <template v-slot:icon>
        <notification-icn
          :class="['ml-3 mr-3 red-icon']"
          width="20px"
          height="20px"
          fill-rule="evenodd"
        ></notification-icn>
      </template>
    </app-year-selector>
    <app-search-input class="top-1 mr-auto" color="red"></app-search-input>
  </div>
</template>

<script>
import AppYearSelector from '@/components/ui/AppYearSelector'
import AppSearchInput from '@/components/ui/AppSearchInput'
import NotificationIcn from '@/assets/icons/notification.svg?inline'

export default {
  name: 'NotificationsTableHeader',

  components: {
    AppYearSelector,
    AppSearchInput,
    NotificationIcn,
  },
}
</script>
<style></style>
